'use strict';

import { environment } from '@quartz-iam-legacy/environments/environment';

angular.module('systemOwnerReviewControllers.ConfirmSystemOwnership')

.controller('ExplanationConfirmSystemOwnershipController', ['$scope', '$state', 'topBar', function ($scope, $state, topBar) {
    topBar.setTitleAndIcon('Step 1 - Confirm System Ownership', 'fa-key');

    $scope.newIamUrl = environment.iamUrl;

    $scope.goToNextExplanationStep = function (step) {
        $state.go('systemOwnerReview.authUser.confirmSystemOwnershipExplanationStep' + step,
                  { authLogin: $scope.authLogin },
                  { reload: true });
    }
}]);
